// extracted by mini-css-extract-plugin
export default {"titletable":"Table_titletable__HRx-G","titletableCell":"Table_titletableCell__jQyyq","titletableTitle":"Table_titletableTitle__bihms"};